import { css } from "@emotion/react";

export const blur = css`
  display: inline-block;
  filter: blur(3px);
  user-select: none;
`;
